import Sdata from '@/database/sdata'


let g_entity = 'member_machine_hour'
let g_url    = 'studio/machinehour'
let g_pkey   = ['uid','machine']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Booking_hour extends Sdata
{
  static entity = g_entity
  static url    = g_url
  static pkey   = g_pkey
}